import PropTypes from 'prop-types';

const ErrorReport = ({
  report,
}) => (
  <div className="mt-2 p-3 bg-red-100 rounded border border-red-300 text-red-800 text-sm">
    <div className="border-b border-red-300 pb-2 mb-2">
      {report.error}
    </div>
    <div className="mb-2">
      {report.details.message}
    </div>
    {!!report.details.class && !!report.details.file && (
      <div>
        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
        A <code className="bg-gray-200 px-1 rounded">{report.details.class}</code> exception was thrown in <code className="bg-gray-200 px-1 rounded">{report.details.file}</code>
      </div>
    )}
  </div>
);

ErrorReport.propTypes = {
  report: PropTypes.shape({
    error: PropTypes.string.isRequired,
    details: PropTypes.shape({
      message: PropTypes.string.isRequired,
      class: PropTypes.string,
      file: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default ErrorReport;
